export default __webpack_public_path__ + "static/media/x.1858fe1b.svg";